export enum HomeRouteName {
    Home = 'home'
}
